module.exports = __webpack_public_path__ + "img/p9.0050ab0b.png";